/*=========================================================================================
  File Name: module-resource-actions.js
  Description: Resource Module Actions
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

export default {
	Resources: function(state) {
		return state.Resources;
	},
	Orders: function(state) {
		return state.Orders;
	},
	UnpaidOrders: function(state) {
		return state.UnpaidOrders;
	},
	IsGetUnpaid: function(state) {
		return state.IsGetUnpaid;
	}
};
